import { __assign } from "tslib";
import React from 'react';
import { measuredDefaultSize, MeasuredContainer, } from '../../Measured';
import TwoColumnLayoutRenderer from './TwoColumnLayoutRenderer';
var TwoColumnLayout = function (props) {
    return (React.createElement(MeasuredContainer, { cookieType: props.cookieType, cookieDim: props.cookieDim, defaultSize: props.defaultSize || measuredDefaultSize, listenOnWindow: props.listenOnWindow || true }, function (measuredProps) {
        var layoutProps = __assign(__assign({}, props), { container: measuredProps.container });
        return (React.createElement(TwoColumnLayoutRenderer, __assign({ measureRef: measuredProps.onRef }, layoutProps)));
    }));
};
TwoColumnLayout.displayName = 'TwoColumnLayout';
export default TwoColumnLayout;
//# sourceMappingURL=TwoColumnLayout.js.map